// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.communities-logo {
    display: inline-block;
    font-family: "Nunito", sans-serif;
    font-size: 30px;
    line-height: 1em;
    font-weight: 300;
    height: 30px;

    padding: 17px 0;

    text-align: left;
}
.communities-logo img {
    display: inline-block;
    width: 32px;
    height: 32px;
    margin-right: 2px;
    margin-bottom: -6px;
}
.communities-logo a:link, .communities-logo a:active, .communities-logo a:visited {
    color: var(--header-text-color);
}

.communities-logo a:hover {
    color: var(--header-text-highlight-color);
}
`, "",{"version":3,"sources":["webpack://./client/components/header/CommunitiesLogo.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,+BAA+B;AACnC;;AAEA;IACI,yCAAyC;AAC7C","sourcesContent":[".communities-logo {\n    display: inline-block;\n    font-family: \"Nunito\", sans-serif;\n    font-size: 30px;\n    line-height: 1em;\n    font-weight: 300;\n    height: 30px;\n\n    padding: 17px 0;\n\n    text-align: left;\n}\n.communities-logo img {\n    display: inline-block;\n    width: 32px;\n    height: 32px;\n    margin-right: 2px;\n    margin-bottom: -6px;\n}\n.communities-logo a:link, .communities-logo a:active, .communities-logo a:visited {\n    color: var(--header-text-color);\n}\n\n.communities-logo a:hover {\n    color: var(--header-text-highlight-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
